import React from 'react';

const Services = () => {
    return (
        <div className="container-xxl py-5">
            <div className="container">
                <div className="text-center wow fadeInUp" data-wow-delay="0.1s">
                    <h6 className="section-title bg-white text-center text-primary px-3">
                        Services
                    </h6>
                    <h1 className="mb-5">What We Offer</h1>
                </div>

                <div className="row g-4 justify-content-center ">
                    <div className="col-lg-3 col-sm-6 wow fadeInUp" data-wow-delay="0.1s">
                        <div className="service-item rounded pt-3">
                            <div className="p-4 text-center">
                                <i className="fa fa-3x fa-suitcase text-primary mb-4" />
                                <h5>Expertly Curated Travel</h5>
                                <p>
                                    Thoughtfully designed itineraries guided by professional travel
                                    advising, insider access, and trusted global partners.
                                </p>
                            </div>
                        </div>
                    </div>

                    <div className="col-lg-3 col-sm-6 wow fadeInUp" data-wow-delay="0.3s">
                        <div className="service-item rounded pt-3">
                            <div className="p-4 text-center">
                                <i className="fa fa-3x fa-bed text-primary mb-4" />
                                <h5>Strategic Hotel Sourcing</h5>
                                <p>
                                    Premium accommodations secured through deep hospitality
                                    relationships, negotiated rates, and attention to comfort and
                                    character.
                                </p>
                            </div>
                        </div>
                    </div>

                    <div className="col-lg-3 col-sm-6 wow fadeInUp" data-wow-delay="0.5s">
                        <div className="service-item rounded pt-3">
                            <div className="p-4 text-center">
                                <i className="fa fa-3x fa-map-signs text-primary mb-4" />
                                <h5>Local Insight & Access</h5>
                                <p>
                                    Personalized recommendations and on-the-ground insight that help
                                    you experience each destination with confidence and ease.
                                </p>
                            </div>
                        </div>
                    </div>

                    <div className="col-lg-3 col-sm-6 wow fadeInUp" data-wow-delay="0.7s">
                        <div className="service-item rounded pt-3">
                            <div className="p-4 text-center">
                                <i className="fa fa-3x fa-calendar-check text-primary mb-4" />
                                <h5>Seamless Planning</h5>
                                <p>
                                    End-to-end coordination, logistics, and execution—so every detail
                                    feels intentional and every journey feels effortless.
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

    )
}

export default Services;
